import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar"
import { AppSidebar } from "@/components/common/AppSidebar"
import { NavHeader } from "@/components/common/NavHeader"

interface DashboardLayoutProps {
	children: React.ReactNode
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
	return (
		<SidebarProvider defaultOpen={false}>
			<AppSidebar />
			<SidebarInset>
				<NavHeader />
				<main className="h-[calc(100vh-3.5rem)] overflow-y-auto">
					<div className="p-4 md:p-6 lg:p-8">
						<div className="flex flex-col gap-4 md:gap-6">{children}</div>
					</div>
				</main>
			</SidebarInset>
		</SidebarProvider>
	)
}
